import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FileType } from '@core/config/file-type';
import { ArquivoService } from '@core/services/arquivo.service';
import { TipoDocumentoService } from '@core/services/tipodocumento.service';

@Component({
  selector: 'app-documento-movimentacao-societaria-form',
  templateUrl: './documento-movimentacao-societaria-form.component.html',
  styleUrls: ['./documento-movimentacao-societaria-form.component.scss']
})
export class DocumentoMovimentacaoSocietariaFormComponent implements OnInit {

  @Output() dadosDocumentoMovimentacaoSocietariaEmit = new EventEmitter<any>();
  @Input() documento: any;
  @Input() dataSet: any;

  observacoesDocForm!: FormGroup;
  tipoDocumentoList: any;
  arquivos: any[] = [];
  objetoEnvio: any;
  arquivoRecebido: any;
  dataCadastro!: any;

  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;

  isFileTypeAccepted: string[] = [
    ...FileType.PDF,
    ...FileType.XLS,
    ...FileType.XLSX,
    ...FileType.DOC,
    ...FileType.DOCX,
    ...FileType.MSG,
    ...FileType.PST,
    ...FileType.JPEG,
    ...FileType.JPG,
    ...FileType.PNG,
    ...FileType.EML
  ];

  constructor(
    private fb: FormBuilder,
    private tipoDocumentoService: TipoDocumentoService,
    private arquivoService: ArquivoService
  ) { }

  arquivosEmit(item: any) {
      if(item) {
        this.arquivos = item;
        this.documento = item;
        this.enviarDocumento();
      }
  }

  ngOnChanges(): void {
    if(this.documento) {
      this.observacoesDocForm.patchValue(this.documento);
    }
  }

  ngOnInit(): void {
    this.inserir = true;
    this.buildForm();

    this.tipoDocumentoService.listar().subscribe(tiposDocumento => {
      this.tipoDocumentoList = tiposDocumento;
      // console.log(this.tipoDocumentoList);

    });
  }

  buildForm(): void {
    this.observacoesDocForm = this.fb.group({
      // nomeDocumento: [''],
      tipoDocumentoId: ['', Validators.required],
      observacoesDoc: [''],
    })
  }

  enviarDocumento(): void {
    const arquivo = this.documento[0];
    this.arquivoService.salvarArquivo(arquivo.file).subscribe({
      next: (data) => {
        this.arquivoRecebido = {
          ...data,
          nomeDocumento: arquivo.file.name
        };
      },
      error: () => {
        this.arquivos = [];
        this.documento = [];
        this.arquivoRecebido = null;
      }
    });
  }

  removerArquivo() {
    this.arquivoService.deletarArquivo(this.arquivoRecebido?.id).subscribe(res => {
      this.arquivos = [];
      this.arquivoRecebido = null;
    })
  }

  salvar(){
    let objEnvio = { ...this.observacoesDocForm.getRawValue() };

    let tipoDocumentoString = '';
    this.tipoDocumentoList.forEach((tipo: any) => {
      if (tipo.id === +this.observacoesDocForm.get('tipoDocumentoId')?.value) {
        tipoDocumentoString = tipo.nomeTipoDocumento;
      }
    });

    objEnvio.tipoDocumentoString = tipoDocumentoString || '';
    objEnvio.arquivoId = this.arquivoRecebido?.id;
    objEnvio.nomeDocumento = this.arquivoRecebido?.nomeDocumento;
    objEnvio.dataCadastro = this.arquivoRecebido?.dataCadastro;

    this.dadosDocumentoMovimentacaoSocietariaEmit.emit(objEnvio);
    this.reset();
  }

  reset() {
    this.observacoesDocForm.reset();
    this.arquivoRecebido = null;
    this.arquivos = [];
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }

    if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }
    else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    }
    else {
      return a === b;
    }
  }
}
